import { Button, Stack } from "@mui/material";
import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { UseSelectorI } from "interfaces";
import { useTranslation } from "_metronic/i18n/language";
import { useThemeApp } from "_metronic/materialUIThemeProvider/ThemeProvider";

interface Props {
  module: string;
  onCancel?: () => void;
  onCreateEdit?: () => void;
  onReset?: () => void;
  disableSubmit?: boolean;
}
const FormActions = ({
  module,
  onCancel,
  onCreateEdit,
  onReset,
  disableSubmit
}: Props) => {
  const translate = useTranslation();
  const { isDarkMode } = useThemeApp();
  const backgroundColorTheme = isDarkMode ? "dark" : "light";

  const buttonStyles = {
    color: "white"
  };

  return (
    <Card.Footer
      style={{
        backgroundColor: backgroundColorTheme,
        textAlign: "end"
      }}
      className="border-0"
    >
      <Stack
        sx={{ marginTop: "3px" }}
        justifyContent="flex-end"
        alignItems="flex-end"
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
      >
        {onCancel ? (
          <Button
            variant="contained"
            color="error"
            onClick={onCancel}
            className="mr-3"
            sx={buttonStyles}
          >
            {translate("buttons.cancel")}
          </Button>
        ) : (
          <Link to={`/admin/${module}`}>
            <Button
              variant="contained"
              color="error"
              type="button"
              className="mr-3"
              sx={buttonStyles}
            >
              {translate("buttons.cancel")}
            </Button>
          </Link>
        )}

        <Button
          variant="contained"
          color="warning"
          onClick={onReset}
          className="mr-3"
          type="reset"
          sx={buttonStyles}
        >
          {translate("buttons.clean")}
        </Button>
        <Button
          variant="contained"
          color="success"
          className="btb-success"
          type="submit"
          disabled={disableSubmit}
          sx={buttonStyles}
        >
          {translate("buttons.save")}
        </Button>
      </Stack>
    </Card.Footer>
  );
};

export default FormActions;
